import { CUSTOMER_JOURNEY_EVENTS_CATEGORIES } from './../const';

function action(token, lang, context, successCallback, errorCallback) {
  return { type: CUSTOMER_JOURNEY_EVENTS_CATEGORIES, token, lang, context, successCallback, errorCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyEventsCategories.js